import React, { Component } from 'react'
import UserRow from '../Users/UserRow.js'
import UserBlock from '../Users/UserBlock.js'
import TitleBar from '../TitleBar/index.js'
import NoteForm from '../NoteForm'
import getLabel from '../../utilities/label.js'
import getMediaIcon from '../../utilities/mediaIcon.js'
import getMediaLabel from '../../utilities/mediaLabel.js'
// import { confirmAlert } from 'react-confirm-alert'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import 'moment-timezone'
import './sessions.css'
import PeerToPeerDetail from './PeerToPeerDetail'

export default class Session extends Component {
  constructor(props) {
    super(props)
    var session = this.getSession(props.match.params.id)
    var noteTakingStatus = this.props.location.state ? this.props.location.state.isTakingNotes : false
    const goBackToNoteIndex = noteTakingStatus
    this.state = {
      session_id: props.match.params.id,
      isRefreshing: false,
      session: session,
      oneOnOneMeetings: session.one_on_one_meetings,
      commentText: '',
      isTakingNotes: noteTakingStatus,
      goBackToNoteIndex: goBackToNoteIndex,
      peerToPeerOptIn: session.has_1_on_1_platform_opt_in
    }
    this.handleBlockP2P = this.handleBlockP2P.bind(this)
    this.refresh = this.refresh.bind(this)
    this.updateComment = this.updateComment.bind(this)
    this.addComment = this.addComment.bind(this)
    this.toggleNote = this.toggleNote.bind(this)
    this.props.setActiveTab('agenda', false)
    window.trackPage('SessionDetailScreen', props.match.params.id)
  }

  componentDidMount() {
    // scroll to top
    window.scrollTo(0,0)
  }

  toggleNote(){
    // if you came from the notes index go back to the notes index
    if (this.state.goBackToNoteIndex) {
      this.props.history.push('/notes')
      // otherwise show this component again
    } else {
      this.setState({
        isTakingNotes: !this.state.isTakingNotes
      })
    }
  }

  removeEditingState() {
    this.setState({
      isTakingNotes: !this.state.isTakingNotes
    })
  }

  isModerator(speakers) {
    var moderators = []
    _.each(speakers, function(speaker) {
      if(speaker.speaker_label === 'Moderator'){
        moderators.push(speaker)
      }
    })
    return moderators
  }

  orderSpeakers(speakers, users) {
    _.each(users, function(user){
      var speaker = _.find(speakers, {user_id: parseInt(user.user_id, 10)})
      user.display_rank = speaker.display_rank
    })
    return users = _.sortBy(users, 'display_rank')
  }

  getSpeakers(){
    let moderator
    const speakers = _.map(this.state.session.event_session_speakers, function(speaker){ return speaker})
    const user_ids = _.map(speakers, function(speaker){ return speaker.user_id})
    var users = _.filter(this.props.users.event_users, function(user){
      return (_.indexOf(user_ids, user.user_id) > -1)
    })
    const moderators = this.isModerator(speakers)
    var sortedUsers = this.orderSpeakers(speakers, users)
    speakers.forEach((speaker) => {
      if(moderators.includes(speaker)){
        moderator = _.find(users, {user_id: parseInt(speaker.user_id, 10)})
        if(moderator) {
          moderator.isModerator = true
        }
      }
    })
    const elements = []
    _.each(sortedUsers, function(user){
      elements.push(
        <div key={user.id}>
          <UserRow
            user={user}
            activeTab="agenda"
            isModerator={user.isModerator}
            dimUsers={true}/>
          <hr />
        </div>
      )
    })
    return elements
  }

  getUserFromUserID(user_id) {
    return _.find(this.props.users.event_users, {user_id: parseInt(user_id, 10)})
  }

  getSession(id) {
    return _.find(this.props.sessions.sessions, {id: parseInt(id, 10)})
  }

  getMedia() {
    if(this.state.session.attachments){
      const attachments = []
      _.each(this.state.session.attachments, (attachment, index) => {
        let style = {}
        // if this is the last in the list then add some extra padding
        if (index === this.state.session.attachments.length - 1) {
          style.marginBottom = '35px'
        }
        attachments.push(
          <li style={ style }>
            <a href={attachment.url} target='_blank' rel='noopener noreferrer' className={'session-attachment ' + attachment.type }>
              <span className="attachment-icon pull-left">{getMediaIcon(attachment.type)}</span>
              <ul>
                <li className="attachment-title">{attachment.title}</li>
                {getMediaLabel(attachment)}
              </ul>
              <span className='pull-right chevron'><i className="fa fa-chevron-right" aria-hidden="true"></i></span>
            </a>
          </li>)
      })
      return attachments
    }
  }

  getSponsorLogo(sponsor) {
    if(sponsor.logo) {
      return <img style={{maxHeight: '80px'}} src={sponsor.logo} alt='' />
    } else {
      return <h4>{sponsor.name}</h4>
    }
  }

  getSponsor() {
    const sponsor = _.find(this.props.sponsors.sponsors, {id: parseInt(this.state.session.sponsor_id, 10)})
    if(sponsor) {
      return <div className='sponsor-row'> <span className='blue-header'><h4>{getLabel('sponsor')}</h4></span><Link to={'/sponsor/' + sponsor.id}>{this.getSponsorLogo(sponsor)}</Link></div>
    }
  }

  getComments(){
    var comments =[]
    _.each(this.state.session.comments, (comment) => {
      comments.push(
        <div className='user-comment' key={comment.id} >
          <span className="time-ago">{comment.ago}</span>
          <UserBlock noHover={true} user={this.getUserFromUserID(comment.user_id)} />
          {comment.comment}<br /><hr />
        </div>)
    })
    return comments
  }

  getAttachments(){
    return <h4>Attachments (TODO)</h4>
  }

  updateComment(e){
    this.setState({
      commentText: e.target.value
    })
  }

  addComment(){
    let data = {
      event_session_id: this.state.session.id,
      body: this.state.commentText
    }
    this.props.postResource({ key: 'comment', data: data, callback: (comment) => {
      this.setState({ commentText: ''})
      if(comment.id) {
        this.props.flashMessage({
          message: getLabel('comment_saved'),
          type: 'success'
        })
        return false
      }
    }})
  }

  commentCounter() {
    return this.state.session.comments.length
  }

  takeToEval(session) {
    if(!session.evaluation_completed) {
      // adjusted time here, because browser epoch time is 3 orders of magnitude greater than what we pass down from API
      let adjustedCurrentTime = (Date.now()/1000)

      // if session start time greater than current -- do not allow user to access evaluation
      if (adjustedCurrentTime < session.epoch_start_time) {
        this.props.flashMessage({
          message: getLabel('session_has_not_started'),
          type: 'error'
        })
      } else {
        this.props.history.push('/session_evaluation/' + session.id)
      }
    }
  }

  handleOptIn() {
    let token = JSON.parse(localStorage.getItem('logged_in_user')).survey_user_token
    let url = `/${token}/profile/wizard?wizard_from=web`
    this.setState({
      isRefreshing: true
    })
    this.props.updateResource({
      key: 'opt_in_p2p',
      callback: () => {
        this.props.updateResource({
          key: 'homepage',
          callback: () => {
            this.setState({
              isRefreshing: false,
              peerToPeerOptIn: true
            })
            this.refresh()
          }
        })
      }
    })
    window.open(url)
  }

  getPeerToPeerHeader(session) {
    if(window.currentUser.registration_status === 'registration_status_approved' && session.one_on_one_wizard_is_complete != null) {
      return (
        <span className='blue-header'><h4>Peer-to-Peer Meetings</h4></span>
      )
    } else {
      return ( null )
    }
  }

  handleBlockP2P(id) {
    let canceledPeerToPeer = this.state.oneOnOneMeetings.find(meeting => meeting.id == id)
    // update these properties below on front end so it takes on "blocked timeslot" state
    canceledPeerToPeer.id = null
    canceledPeerToPeer.opted_out = true
    let array = this.state.oneOnOneMeetings
    let index = array.map(mtg => mtg.id).indexOf(id)
    array[index] = canceledPeerToPeer
    this.setState({
      oneOnOneMeetings: array
    })
  }

  getPeerToPeer(session) {
    let peerToPeers = _.sortBy(this.state.oneOnOneMeetings, function(meeting) {
      return meeting.epoch_start_time
    })
    const elements = []
    if(session.one_on_one_wizard_is_complete != null) {
      // n is so we know to add <hr> element on top of component if n > 1
      let n = 0
      if(window.currentUser.registration_status === 'registration_status_approved') {
        peerToPeers.forEach((peerToPeer) => {
          elements.push(
            <div>
              <PeerToPeerDetail
                num={n}
                peerToPeer={peerToPeer}
                handleBlockP2P={this.handleBlockP2P}
                history={this.props.history}
              />
            </div>
          )
          n += 1
        })
      }
    }
    return elements
  }

  // optInModal() {
  //   confirmAlert({
  //     title: 'Opt in to Participate in Peer-to-Peer Meetings',
  //     message: 'Peer-to-Peer Meetings are 25-minute, one-on-one meetings with peers in your community. I agree to participate in Peer-to-Peer Meetings as part of this event.',
  //     buttons: [
  //       {
  //         label: 'Cancel',
  //       },
  //       { label: 'Continue',
  //         onClick: () => {this.handleOptIn()},
  //         className: 'solar-button'
  //       }
  //     ],
  //     closeOnEscape: true,
  //     closeOnClickOutside: true,
  //   })
  // }

  navigateToWizard() {
    window.open(`/${window.currentUser.survey_user_token}/profile/wizard?wizard_from=web`,'_self')
  }

  registrationButton(session) {
    let buttonLabel = ''
    let buttonClass = ''
    let buttonAction = ''
    // button actions
    if(session.session_type_key === 'session_type_one_to_one_meeting') {
      buttonAction = () => { this.navigateToWizard() }
    } else {
      buttonAction = () => { this.toggleStatus(session) }
    }
    // button labels and classes
    if(session.session_type_key === 'session_type_one_to_one_meeting' && session.one_on_one_wizard_is_complete) {
      buttonLabel = 'Edit Peer-to-Peer Setup'
      buttonClass = 'register'
    } else if(session.session_type_key === 'session_type_one_to_one_meeting' && !session.one_on_one_wizard_is_complete) {
      buttonLabel = 'Complete Peer-to-Peer Setup'
      buttonClass = 'complete-p2p'
    } else if(session.registration_status === 'double_booked') {
      buttonLabel = getLabel('register')
      buttonClass = 'register'
    } else if(session.registration_status === 'un_register') {
      buttonLabel = getLabel('un_register')
      buttonClass = 'unregister'
    } else if(session.registration_status === 'not_authorized') {
    // do not display
    } else if(session.registration_status === 'session_full') {
      buttonLabel = `${getLabel('reg_label_session_is')} ${getLabel('reg_label_full')}`
      buttonClass = 'unregister-disabled'
    } else {
      buttonLabel = getLabel('register')
      buttonClass = 'register'
    }
    // return elements with actions, labels and classes
    if (window.currentUser.registration_status === 'registration_status_approved' && session.session_type_key === 'session_type_one_to_one_meeting' || session.registration_status === 'session_full') {
      return (
        <div>
          <button
            className={ buttonClass }
            onClick={ buttonAction }
            disabled={ this.disabledButton() }
          >
            { buttonLabel }
          </button>
          <br />
        </div>
      )
    } else if (buttonLabel && buttonClass) {
      return (
        <div>
          <button
            className={ buttonClass }
            onClick={ buttonAction }>
            <i className='fa fa-check-circle'></i> { buttonLabel }
          </button>
          <br />
        </div>
      )
    }
  }

  disabledButton() {
    if (this.state.session.registration_status === 'session_full' && this.state.session.session_type_key !== 'session_type_one_to_one_meeting') {
      return true
    }
  }

  toggleStatus(session) {
    var data = {
      id: session.id
    }
    this.props.postResource({ key: 'session_registration', data: data, callback: (response) => {
      if(response.data.event_session_registration.registration_status === 'double_booked') {
        this.props.flashMessage({
          message: getLabel('schedule_conflict'),
          type: 'error'
        })
        return false
      } else if(response.data.event_session_registration.registration_status === 'session_full') {
        this.props.flashMessage({
          message: 'This session is full.',
          type: 'error'
        })
        return false
      }
    }})
  }

  regHelperText(session) {
    // var hidden = session.registration_required ? '' : 'hide'
    if(session.registration_status === 'not_authorized'){
      return <div className="reg-helper-text">{ getLabel('reg_label_invite') + ' ' + getLabel('asterisks_are_required') }</div>
    } else if (session.registration_required && session.session_type_key != 'session_type_one_to_one_meeting') {
      return <div className="reg-helper-text">{getLabel('reg_label_rsvp') + ' ' + getLabel('asterisks_are_required')}</div>
    } else {
      return ''
    }
  }

  sessionPoll(session) {
    if(session.poll_url) {
      return <a href={session.poll_url} target='_blank' rel='noopener noreferrer'><button className='poll'><i className='fa fa-question-circle-o'></i> Participate in Poll</button></a>
    }
  }

  externalUrl(session) {
    if(session.external_url && session.external_url_label) {
      return (
        <a href={session.external_url} target='_blank' rel='noopener noreferrer'>
          <button>{ session.external_url_label }</button>
        </a>
      )
    }
  }

  location() {
    const { session } = this.state
    if (session.is_alt_venue) {
      return (
        <div>
          <p className="alt-venue">{ session.venue_name }</p>
          <p className="alt-venue">{ session.address }</p>
          <p className="alt-venue">{ session.city }, { session.state } { session.postal_code }</p>
          <p>{ session.session_type }</p>
        </div>
      )
    } else {
      return (
        // if no room name, display nothing, else, display room name with dash
        <p>{session.room_name == null ? '' : session.room_name + ' - '}{session.session_type}</p>
      )
    }
  }

  refresh() {
    if (this.state.isRefreshing) {
      return
    } else {
      this.setState({ isRefreshing: true })
      this.props.getResource({
        key: 'sessions',
        update: true,
        callback: () => {
          this.props.getResource({
            key: 'sponsors',
            update: true,
            callback: () => {
              this.props.getResource({
                key: 'users',
                update: true,
                callback: () => {
                  this.setState({
                    isRefreshing: false,
                    session: this.getSession(this.state.session_id),
                    oneOnOneMeetings: this.getSession(this.state.session_id).one_on_one_meetings
                  })
                }
              })
            }
          })
        }
      })
    }
  }

  render() {

    const refreshButton = this.state.isRefreshing ?
      '<i class=\'fa fa-refresh fa-spin\'></i>' :
      '<i class=\'fa fa-refresh\'></i>'
    const {
      session,
      commentText,
      isTakingNotes } = this.state
    const hasNote = session.note_on_session ? 'active-button' : ''
    const hasEval = session.evaluation_completed ? 'active-button' : ''
    const canTakeEval = !window.currentUser.can_take_session_survey ||
                        session.registration_status === 'not_authorized' ||
                        session.session_type_key === 'session_type_one_to_one_meeting' ||
                        (session.evaluation_taken_in_timeblock && !session.evaluation_completed) ? 'hide' : ''
    const hasMedia = session.attachments.length > 0
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    if(!session) {
      return (
        <div><a onClick={() => window.history.back()}>back</a><div>Session not found.</div></div>
      )
    }
    if(!isTakingNotes) {
      return (
        <div className='session-page'>
          <TitleBar
            title={ session.name }
            rightButtonLabel={ refreshButton }
            rightButtonAction={ this.refresh }
            leftButtonLabel={ backButton }
            leftButtonAction={ () => window.history.back() } />
          <h4>{session.name}</h4>
          <div className='session-schedule'>
            <div className='session-time'>
              { session.formatted_display_date }
            </div>
            { this.location() }
          </div>
          <div className='session-actions'>
            { this.regHelperText(session) }
            { this.registrationButton(session) }
            { !canTakeEval &&
              <div>
                <button className={'take-eval ' + hasEval + ' ' + canTakeEval} onClick={() => this.takeToEval(session)}><i className='fa fa-check-square-o'></i> {session.evaluation_completed ? 'Evaluation Complete' : 'Take Evaluation'}</button>
                <br></br>
              </div>
            }
            <button className={'note ' + hasNote} onClick={ this.toggleNote } >
              <i className="fa fa-sticky-note-o"></i> {getLabel('note')}
            </button>
            { this.sessionPoll(session) }
            { this.externalUrl(session) }
          </div>
          { this.getPeerToPeerHeader(session) }
          { this.getPeerToPeer(session) }
          <span className='blue-header'><h4>Session Details</h4></span>
          { this.getSpeakers() }
          <br />
          <p dangerouslySetInnerHTML={{__html: session.body}} ></p>
          { hasMedia &&
            <div className={'media-section' }>
              <span className='blue-header'><h4>{getLabel('media')}</h4></span>
              <ul>
                { this.getMedia() }
              </ul>
            </div>
          }
          { this.getSponsor() }
          <div className="form-group comment-form">
            <div className='comment-form-header'>
              <span className='blue-header'><h4 key="comments">Comments ({this.commentCounter()})</h4></span>
              <textarea className="form-control" value={ commentText } onChange={ this.updateComment } />
              <button className="save-comment" onClick={ this.addComment }>Comment</button><br />
            </div>
            <br />
            <div className='comments'>
              {this.getComments()}
            </div>
          </div>
          <pre className="debug-json">{JSON.stringify(session, false, 2)}</pre>
        </div>
      )
    } else {
      return (
        <NoteForm
          postResource={ this.props.postResource }
          note={ session.note_on_session }
          sessionName={ session.name }
          toggleNote={ this.toggleNote }
          flashMessage={ this.props.flashMessage }
          noteType={ 'sessionNote' }
          postData={{ event_session_id: session.id }} >
          <div className='session-schedule' onClick={ () => {this.removeEditingState()} } >
            <h4>{ session.name }</h4>
            <div className='session-time'>
              { session.formatted_display_date }
            </div>
            <p>{ session.room_name } - { session.session_type }</p>
          </div>
        </NoteForm>
      )
    }
  }
}
